import React, { useState, useEffect} from "react"
import { Alert, Row, Col, Form, Label, Input ,ButtonGroup} from "reactstrap"
import Switch from "react-switch"
import Offsymbol from "../../components/Common/Offsymbol"
import OnSymbol from "../../components/Common/OnSymbol"
import { Fragment } from "react"
import { useTranslation } from "react-i18next"
import { withRouter } from "react-router-dom"
import { is_empty } from "../../config/validate"
import LabelChargeData from "../../components/Common/labelChargeData"
import showToast from "../../components/Common/viewNotification"
//redux
import { useSelector, useDispatch } from "react-redux"
import { saveConcept, cleanConcept } from "../../store/actions"

const ConceptForm = props => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  // eslint-disable-next-line react/prop-types
  const { onClosing, isEdit, currentConcept, onLoad ,onClean} = props
  const [name, setName] = useState({ value: "", error: "" })
  const [code, setCode] = useState({ value: "", error: "" })
  const [status, setStatus] = useState(true)
  const [auth] = useState(JSON.parse(sessionStorage.getItem("user")))
  let [errors, setErrors] = useState([])
  //#region storage
  const { loading, responseConcept, error } = useSelector(state => ({
    loading: state.Concept.loadingSave,
    responseConcept: state.Concept.current,
    error: state.Concept.error,
  }))
  //#endregion
 
  useEffect(() => {
    if (responseConcept !== null) {
        showToast(responseConcept?.response?.name, "success", t("concept:add"))
        clearForm()
        dispatch(cleanConcept())
        onLoad()
    }

  }, [responseConcept])
  useEffect(() => {
    if (currentConcept) {
      setData()
    }
  }, [currentConcept])
  const handleSubmit = () => {
    validate()
    if (errors.length === 0) {
      let values = {
        name: name.value,
        code: code.value,
        createdBy: auth.id.user.username,
        status: 1,
      }
      if (isEdit) {
        values.id = currentConcept === null ? null : currentConcept.id
        values.status = status ? 1 : 0
      }

      dispatch(saveConcept(values))
    }
  }
  const validate = () => {
    errors = []
    if (is_empty(name.value)) {
      name.error = t("error:required")
      errors.push(name.error)
    }
    if (is_empty(code.value)) {
      code.error = t("error:required")
      errors.push(code.error)
    }

    setErrors(errors)
  }
  const clearForm = async () => {
    if (!isEdit) {
      setName({ value: "", error: "" })
      setCode({ value: "", error: "" })
    }else{
      currentConcept.name=name.value
    }
  }
  const setData = () => {
    setName({ value: currentConcept.name, error: "" })
    setCode({ value: currentConcept.code, error: "" })
    setStatus(currentConcept.status === 1 ? true : false)
  }
  return (
    <React.Fragment>
      {isEdit ? (
        <Alert color="primary">
          {currentConcept === null ? "" : currentConcept.name}
        </Alert>
      ) : null}
      <Form>
        <Row>
          <Col xs={12}>
            <div className="mb-3">
              <Label htmlFor="name">{t("concept:name")}</Label>
              <Input
                autoComplete="new-text"
                type="text"
                className="form-control"
                value={name.value || ""}
                onChange={e => {
                  setName({ value: e.target.value, error: "" })
                }}
                invalid={!is_empty(name.error)}
              />
              <span className="small text-danger">{name.error}</span>
            </div>
            <div className="mb-3">
              <Label htmlFor="name">{t("concept:code")}</Label>
              <Input
                autoComplete="new-text"
                type="text"
                className="form-control"
                value={code.value || ""}
                onChange={e => {
                  setCode({ value: e.target.value, error: "" })
                }}
                invalid={!is_empty(code.error)}
                disabled={isEdit}
              />
              <span className="small text-danger">{code.error}</span>
            </div>
            {isEdit ? (
              <Fragment>
                <Label>{t("global:active")}? &nbsp; &nbsp; </Label>
                <Switch
                  uncheckedIcon={<Offsymbol />}
                  checkedIcon={<OnSymbol />}
                  className="me-1 mb-sm-8 mb-2"
                  onColor="#626ed4"
                  onChange={() => {
                    setStatus(!status)
                  }}
                  checked={status}
                />
              </Fragment>
            ) : null}{" "}
          </Col>
        </Row>
        <Row>
          <Col>
            <LabelChargeData
              label={""}
              showloading={loading}
              title={t("global:registerloading")}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="modal-footer">
            <ButtonGroup>
              <button
                type="button"
                className="btn btn-info save-user"
                disabled={loading}
                onClick={handleSubmit}
              >
                <i className=" fas fa-save me-1 " />
                {t("global:save")}
              </button>
              <button
                type="button"
                className="btn btn-danger "
                disabled={loading}
                onClick={() => {
                  if (!isEdit) {
                    onClosing(false)
                  } else{
                    onClean()
                  }
                }}
              >
                {" "}
                {t("global:close")}
              </button>
              </ButtonGroup>
            </div>
          </Col>
        </Row>
      </Form>
    </React.Fragment>
  )
}

export default withRouter(ConceptForm)
